<template>
  <CustomizationTool :key="customisationToolKey" :market-slug="slug" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import CustomizationTool from '~/components/price-assessments/customisation-tool.vue'
import type { TProduct } from '~/src/types/product'
import useAuthStore from '~/stores/auth'

const props = defineProps<{
  product: TProduct
}>()

const authStore = useAuthStore()
const customisationToolKey = ref(0)
const slug = computed(() => props.product.reportSlug || props.product.slug)
const isAuthenticated = computed(() => authStore.authenticated)

watch(isAuthenticated, () => {
  customisationToolKey.value += 1
})
</script>
